import { IconName } from '@/components/Icon/Icon';

export const ENVIRONMENT_MAPPING: Record<VercelEnvironment, string> = {
  production: 'prd',
  preview: 'stg',
  development: 'dev',
};

interface BasketProduct {
  value: number;
  icon: IconName;
  label: string;
}

const BASKET_PRODUCT_HEAT_PUMP: BasketProduct = {
  value: 5,
  icon: 'HeatPump',
  label: 'common_heatpump',
};

export const BASKET_PRODUCTS: BasketProduct[] = [
  {
    value: 4,
    icon: 'Heartbeat',
    label: 'common_heartbeat',
  },
  {
    value: 1,
    icon: 'SolarPower',
    label: 'common_solarPanels',
  },
  {
    value: 2,
    icon: 'Zap',
    label: 'common_battery',
  },
  {
    value: 3,
    icon: 'EV',
    label: 'common_wallbox',
  },
];

export const BASKET_PRODUCTS_WITH_HEATPUMP: BasketProduct[] = [
  ...BASKET_PRODUCTS,
  BASKET_PRODUCT_HEAT_PUMP,
];
